import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/Checkbox';
import styles from './index.module.scss';
import cn from 'classnames';
import EmbeddedEvidenceForm from '../../containers/Task/Form/EmbededEvidence';
import EvidenceForm from '../Forms/Fields/EvidenceForm';
import PopUp from '../Operational/PopUp/PopUp';
import { PAGE_URLS } from 'utils/constants';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { popupText } from 'utils/constants/popupText';
import { useTranslation } from 'react-i18next';

const PatrolPath = ({
  value,
  handleChange,
  onEvidenceChange,
  locationEvidence,
  displayEvidence,
  virtualPatrolHandleChange,
  checkpointDetails,
  viewName,
  formProps,
  mediaOnChange,
  patrolEvidenceOptions,
  isPatrolInstancePanel,
}) => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [evidenceForm, setEvidenceForm] = useState(false);
  const [patrolledCheckbox, setPatrolledCheckbox] = useState();
  const [evidenceKey, setEvidenceKey] = useState();

  const evidenceChange = (evidence, updatedCheckpointDetails) => {
    return onEvidenceChange({
      value: evidence,
      seqNumber: evidence.seqNumber,
      point: updatedCheckpointDetails,
    });
  };
  const isEvidenceCollected = ({ e, marker }) => {
    // The checkpoint needs to map to the sequence number and QR code as in some cases we have first point equal to last point
    const currentCheckpoint = checkpointDetails.find(
      detail =>
        detail.qrCode === marker?.qrCode &&
        marker.seqNumber === detail.seqNumber,
    );
    let taskIncomplete = {};
    if (currentCheckpoint?.evidence) {
      taskIncomplete = currentCheckpoint?.evidence.find(
        evidence => !evidence.completed,
      );
    }

    if (taskIncomplete && Object.values(taskIncomplete).length > 0) {
      setPatrolledCheckbox({
        checked: e.target.checked,
        key: marker,
      });
      setShowForm(true);
      setEvidenceKey(marker.seqNumber);
    } else {
      virtualPatrolHandleChange({
        checked: e.target.checked,
        key: marker,
      });
      setEvidenceKey();
    }
  };

  const partialEvidenceUploaded = (formProps, marker) => {
    // check if it has more than 1 evidence
    // if not then this bool remains false
    // if more than one and if any evidence has complete false , the partialUploading becomes true
    const cp = formProps.values.checkPointDetail.find(
      f => f.seqNumber === marker.seqNumber,
    );

    let partialEvUpload = false;
    if (cp.evidence.length > 1) {
      // more than 1 evidence
      const checkIfAllEvidencesUploaded = cp.evidence.filter(ev => {
        return !ev.completed;
      });

      if (checkIfAllEvidencesUploaded.length === cp.evidence.length) {
        // its same
        partialEvUpload = false;
      } else if (checkIfAllEvidencesUploaded.length === 0) {
        // all uploaded
        partialEvUpload = false;
      } else {
        partialEvUpload = true; // evidences provided are 3 but uploaded 2
      }
    } else {
      partialEvUpload = false;
    }

    return partialEvUpload;
  };

  const showEvidence = marker => {
    let isEvidenceCollected = '';
    const locationPatrolledArray = formProps.values?.patrolledLocations;
    const locationPatrolled = locationPatrolledArray.find(
      location =>
        location.definedLocation?.qrCode === marker?.qrCode &&
        location?.seqNumber === marker.seqNumber,
    );
    // The checkpoint needs to map to the sequence number and QR code as in some cases we have first point equal to last point
    const currentCheckpoint = checkpointDetails.find(
      detail =>
        detail.qrCode === marker?.qrCode &&
        marker.seqNumber === detail.seqNumber,
    );

    const taskIncomplete =
      currentCheckpoint?.evidence &&
      currentCheckpoint?.evidence.find(evidence => !evidence.completed);

    if (!locationPatrolled?.taskSuccessful && taskIncomplete) {
      isEvidenceCollected = false;
    } else if (currentCheckpoint?.evidence) {
      if (
        !locationPatrolled?.taskSuccessful &&
        taskIncomplete &&
        Object.values(taskIncomplete).length > 0
      ) {
        isEvidenceCollected = false;
      }
    }

    if (
      // marker.patrolled &&
      locationPatrolled?.taskSuccessful ||
      (currentCheckpoint?.evidence &&
        !currentCheckpoint?.evidence.find(evidence => !evidence.completed))
    ) {
      isEvidenceCollected = true;
    }

    if (currentCheckpoint?.evidence) {
      return (
        <EvidenceForm
          description={currentCheckpoint?.evidence?.description}
          item={marker}
          onChange={evidence =>
            evidenceChange(evidence.evidence, evidence.updatedCheckpointDetails)
          }
          checkpointDetails={currentCheckpoint}
          formProps={formProps}
          mediaOnChange={mediaOnChange}
          isPatrolled={marker.patrolled}
          isEvidenceCollected={isEvidenceCollected}
          openEvidenceDirectly={evidenceForm}
          evidenceFormKey={marker.seqNumber}
          setEvidenceFormDirectly={setEvidenceForm}
          evKey={evidenceKey}
          partialEvidenceUploaded={partialEvidenceUploaded(formProps, marker)}
        />
      );
    }
    return null;
  };

  const isMap = () => {
    if (formProps.values?.siteSurfaceImages?.id === GEOGRAPHICAL_MAP.id) {
      return true;
    }
    return false;
  };

  return (
    <>
      <table className={cn({ [styles.table]: displayEvidence })}>
        <thead className={cn(styles.boundaryHeader)}>
          <tr>
            {isPatrolInstancePanel && (
              <th className={styles.tMargin}>Patrolled</th>
            )}
            <th className={styles.tMargin}>Seq</th>
            <th className={styles.tMargin}>{isMap() ? t('Longitude') : 'X'}</th>
            <th className={styles.tMargin}>{isMap() ? t('Latitude') : 'Y'}</th>
            {!isPatrolInstancePanel && (
              <th className={styles.tMargin}>{t('Checkpoint')}</th>
            )}
            {displayEvidence && (
              <th
                className={cn(styles.tMargin, styles.alignLeft, {
                  [styles.size70]: displayEvidence,
                })}
              >
                {t('Evidence')}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {value.map((marker, key) => {
            return (
              <tr key={`${marker.text}-${key}`}>
                {isPatrolInstancePanel && marker.type === 'WAYPOINT' && (
                  <td className={styles.tMargin}>
                    <div style={{ padding: '18px' }}></div>
                  </td>
                )}
                {isPatrolInstancePanel && marker.type !== 'WAYPOINT' && (
                  <td className={styles.tMargin}>
                    <Checkbox
                      disabled={marker.isPatrolDisabled}
                      onChange={e =>
                        isEvidenceCollected({
                          e,
                          marker,
                        })
                      }
                      name={`${marker.text}`}
                      value={marker.patrolled}
                    />
                  </td>
                )}
                <td className={styles.tMargin}>{marker.text}</td>
                <td className={styles.tMargin}>{marker.lng}</td>
                <td className={styles.tMargin}>{marker.lat}</td>
                {!isPatrolInstancePanel && (
                  <td className={styles.tMargin}>
                    <Checkbox
                      disabled={marker.disabled}
                      onChange={e => handleChange(e, marker)}
                      name={`${marker.text}`}
                      value={marker.type === 'CHECKPOINT'}
                    />
                  </td>
                )}
                {displayEvidence && viewName !== PAGE_URLS.PATROLS.link && (
                  <td className={styles.tMargin}>
                    {marker.type === 'CHECKPOINT' &&
                      !marker.noEmbeddedEvidenceForm && (
                        <EmbeddedEvidenceForm
                          value={locationEvidence}
                          item={marker}
                          onChange={onEvidenceChange}
                          patrolEvidenceOptions={patrolEvidenceOptions}
                        />
                      )}
                  </td>
                )}
                {displayEvidence && isPatrolInstancePanel && (
                  <td className={styles.tMargin}>
                    {marker.type === 'CHECKPOINT' &&
                      !marker.noEmbeddedEvidenceForm &&
                      showEvidence(marker)}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {showForm && (
        <PopUp
          title={popupText.patrolPath.popupTitle}
          statusMessage={popupText.patrolPath.popupStatusMessage}
          submitBtnText={popupText.patrolPath.submitBtnText}
          cancelBtnText={popupText.patrolPath.cancelBtnText}
          submit={() => {
            setShowForm(false);
            setEvidenceForm(true);
          }}
          cancel={() => {
            setShowForm(false);
            virtualPatrolHandleChange(patrolledCheckbox);
            setPatrolledCheckbox();
          }}
          close={() => {
            setShowForm(false);
            setEvidenceForm(false);
          }}
        />
      )}
    </>
  );
};

PatrolPath.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      isWaypoint: PropTypes.bool,
      text: PropTypes.number,
      lng: PropTypes.number,
      lat: PropTypes.number,
      qrCode: PropTypes.string,
    }),
  ),
  handleChange: PropTypes.func,
  onEvidenceChange: PropTypes.func,
  locationEvidence: PropTypes.object,
  displayEvidence: PropTypes.bool,
  isPatrolInstancePanel: PropTypes.bool,
  patrolEvidenceOptions: PropTypes.bool,
  virtualPatrolHandleChange: PropTypes.func,
  viewName: PropTypes.string,
  formProps: PropTypes.object,
  onChange: PropTypes.func,
  mediaOnChange: PropTypes.func,
  checkpointDetails: PropTypes.array,
};

export default PatrolPath;
